import IdentificacionesAsociadas from "../IdentificacionesAsociadas/IdentificacionesAsociadas";

function DatosBasicosPersona({ titulo, personaUnificada }) {
  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">
          {titulo ?? "Datos de la Persona"}
        </h6>
      </div>
      <div className="card-body text-gray-800">
        <div className="form-group row">
          <div className="col-md-3">
            <label
              htmlFor="PersonaUnificada.TipoPersona.Codigo"
              className="col-form-label"
            >
              Tipo Persona
            </label>
            <input
              type="text"
              className="form-control"
              id="PersonaUnificada.TipoPersona.Codigo"
              value={
                personaUnificada.identificacionPrincipal.tipoPersona
                  .descripcionLarga
              }
              readOnly
            />
          </div>

          <div className="col-md-3">
            <label
              htmlFor="PersonaUnificada.IdentificacionPrincipal.Codigo"
              className="col-form-label"
            >
              Identificación
            </label>
            <input
              type="text"
              className="form-control"
              id="PersonaUnificada.IdentificacionPrincipal.Codigo"
              value={personaUnificada.identificacionPrincipal.codigo}
              readOnly
            />
          </div>

          <div className="col-md-6">
            <label
              htmlFor="PersonaUnificada.NombreORazonSocial"
              className="col-form-label"
            >
              Nombre
            </label>
            <input
              type="text"
              className="form-control"
              id="PersonaUnificada.NombreORazonSocial"
              value={personaUnificada.nombreCompleto}
              readOnly
            />
          </div>
        </div>
        {personaUnificada.identificacionesAsociadas.length > 0 ? (
          <IdentificacionesAsociadas
            Identificaciones={personaUnificada.identificacionesAsociadas}
            Titulo="Identificaciones Asociadas"
          />
        ) : null}
      </div>
    </div>
  );
}
export default DatosBasicosPersona;
